<template>
    <div class="layout-topbar">
        <div class="topbar-left">
            <a tabindex="0" class="menu-button" @click="onMenuButtonClick">
                <i class="pi pi-chevron-left"></i>
            </a>

            <router-link to="/" class="horizontal-logo">
                <img id="logo-horizontal" class="horizontal-logo" src="assets/layout/images/logo-white.svg" alt="diamond-layout" />
            </router-link>

            <span class="topbar-separator"></span>
           
            <div class="layout-breadcrumb viewname" style="text-transform: uppercase">
                <template v-if="$route.meta.breadcrumb">
                    <span>{{$route.meta.breadcrumb[0].label}}</span>
                </template>
            </div>

            <img id="logo-mobile" class="mobile-logo" src="assets/layout/images/logo-mides.svg" alt="mides -layout" />
        </div>

        <div class="layout-mask modal-in"></div>

        <div class="topbar-right">
            <ul class="topbar-menu">
                <li class="search-item" style="pointer-events: none;">
                    <a tabindex="0">
                        <!-- <i class="pi pi-search"></i> -->
                    </a>
                </li>
                <li class="notifications-item" :class="{ 'active-menuitem ': topbarNotificationMenuActive }" style="pointer-events: none;">
                    <a href="#" tabindex="0">
                        <!-- <i class="pi pi-bell"></i> -->
                        <!-- <span class="topbar-badge">2</span> -->
                    </a>
                    <ul class="notifications-menu fade-in-up">
                        <li role="menuitem">
                            <a href="#" tabindex="0">
                                <i class="pi pi-check-square"></i>
                                <div class="notification-item">
                                    <div class="notification-summary">Beneficio asigando</div>
                                    <div class="notification-detail">Tienes <strong>1</strong> nuevo beneficio.</div>
                                </div>
                            </a>
                        </li>
                        <li role="menuitem">
                            <a href="#" tabindex="0">
                                <i class="pi pi-check-square"></i>
                                <div class="notification-item">
                                    <div class="notification-summary">Datos personales</div>
                                    <div class="notification-detail">Agregar correo electrónico.</div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="profile-item" :class="{ 'active-menuitem fadeInDown': topbarUserMenuActive }">
                    <a href="#" @click="onTopbarUserMenuButtonClick">
                        <!-- <img src="assets/tumides/images/avatar/profile.jpg" alt="diamond-layout" class="profile-image" /> -->
                        <i class="pi pi-user p-mr-2"></i>
                        <div>
                        <span class="profile-name" >{{getNombre()}}</span>
                        </div>
                    </a>
                    <ul class="profile-menu fade-in-up">
                        <li v-if="false">
                            <a href="datospersonales">
                                <i class="pi pi-user-edit"></i>
                                <span>Datos personales</span>
                            </a>
                        </li>
                        <li v-if="false">
                            <a href="#/inbox">
                                <i class="pi pi-inbox"></i>
                                <span>Inbox</span>
                            </a>
                        </li>
                        <li>
                            <a @click="this.$parent.logout">
                                <i class="pi pi-power-off"></i>
                                <span>Salir</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <!-- <li class="right-sidebar-item">
                    <a href="#" tabindex="0" @click="onRightMenuClick">
                        <i class="pi pi-align-right"></i>
                    </a>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    name: "AppTopbar",
    emits: ["menu-click", "menuitem-click", "root-menuitem-click", "menu-button-click", "search-click", "topbar-notification", "topbar-user-menu", "right-menubutton-click"],
    props: {
        topbarNotificationMenuActive: Boolean,
        topbarUserMenuActive: Boolean,
        layoutMode: String,
        menu: Array,
        menuActive: Boolean,
        staticMenuMobileActive: Boolean,
    },
    data() {
        return {
            items: [],
            nombre:"",
        };
    },
    components: {
        
    },
    unmounted() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    },
    mounted() {

    },
    methods: {
        getNombre(){
            return localStorage.nombre;        	
        },
        onMenuClick(event) {
            this.$emit("menu-click", event);
        },
        onMenuItemClick(event) {
            this.$emit("menuitem-click", event);
        },
        onRootMenuItemClick(event) {
            this.$emit("root-menuitem-click", event);
        },
        onMenuButtonClick(event) {
            this.$emit("menu-button-click", event);
        },
        /* onSearchClick(event) {
            this.$emit("search-click", event);
        }, */
        onTopbarNotificationMenuButtonClick(event) {
            this.$emit("topbar-notification", event);
        },
        onTopbarUserMenuButtonClick(event) {
            this.$emit("topbar-user-menu", event);
        },
        onRightMenuClick(event) {
            this.$emit("right-menubutton-click", event);
        },
        isMobile() {
            return window.innerWidth <= 1091;
        }
    }
};
</script>
